// Example: Apply class if school is 100% down
const isSchoolDown = true; // Set this dynamically

if (isSchoolDown) {
  document.querySelector('.supporting-menu').style.paddingBottom = '100px';
}

class AbzBuyNowButton extends HTMLElement {
  constructor() {
    super();
    this.buyNowButton = this.querySelector('[data-buy-now]');
    if (!this.buyNowButton) return;
    
    this.buyNowButton.addEventListener('click', async (e) => {
        const form = this.buyNowButton.closest('form');
        if (!form) return;

        const formData = new FormData(form);
        const actionUrl = form.getAttribute('action');

        try {
          const response = await fetch(`${actionUrl}.js`, {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) throw new Error('Add to cart failed');
          const result = await response.json();

          window.location.href = '/checkout';
        } 
        catch (err) {
          console.error('Buy Now Error:', err);
          alert('Unable to proceed to checkout.');
        }
      });
  }
}

customElements.define('abz-buy-now-button', AbzBuyNowButton)
